import { render } from "./FormMessage.vue?vue&type=template&id=7649c4a4&ts=true"
import script from "./FormMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormMessage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/form/FormMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7649c4a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7649c4a4', __exports__)) {
    api.reload('7649c4a4', __exports__)
  }
  
  module.hot.accept("./FormMessage.vue?vue&type=template&id=7649c4a4&ts=true", () => {
    api.rerender('7649c4a4', render)
  })

}


export default __exports__